import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import CrossIcon from "../../../assets/icons/cross-grey.svg";
import "./index.less";
import { isMobile } from "../../../utls/FunctionsUtil";

interface ApplicationNameChangeModalProps {
  visible: boolean;
  onClose: () => void;
}

const ApplicationNameChangeModal: React.FC<ApplicationNameChangeModalProps> = ({ visible, onClose }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  const handleOverlayClick = () => {
    onClose();
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  const handleContactButtonClicked = () => {
    const phoneNumber = "+33629661021";
    const message = t("Bonjour, j'ai une question concernant le changement de nom de Loly à Twizz");

    try {
      const whatsappUrl = isMobile()
        ? `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`
        : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

      const newWindow = window.open(whatsappUrl, "_blank");

      if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, "_blank");
      }
    } catch (error) {
      console.error("Erreur lors de l'ouverture de WhatsApp:", error);
      window.open(`https://wa.me/${phoneNumber}`, "_blank");
    }
  };

  return (
    <div className="name-change-modal-overlay no-scroll" onClick={handleOverlayClick}>
      <div className="name-change-modal-content no-scroll-horizontal" onClick={handleModalClick}>
        <div className="w-full d-flex justify-content-center" onClick={onClose}>
          <div className="name-change-modal-line-header"></div>
        </div>
        <img src={CrossIcon} className="cross-icon" alt="cross" onClick={onClose} />

        <div className="name-change-modal-wrapper">
          <Typography.Text className="name-change-modal-title">{t("name-change-title")}</Typography.Text>
          <Typography.Text className="name-change-modal-description">
            {t("name-change-description-part1")} <span className="white">{t("name-change-description-part2")}</span>
          </Typography.Text>

          <div className="name-change-modal-info-container">
            <Typography.Text className="name-change-modal-info-title">{t("name-change-reason-title")}</Typography.Text>
            <Typography.Text className="name-change-modal-info-description">{t("name-change-reason-description")}</Typography.Text>
          </div>

          <div className="name-change-modal-info-container">
            <Typography.Text className="name-change-modal-info-title">{t("name-change-features-title")}</Typography.Text>
            <Typography.Text className="name-change-modal-info-description">{t("name-change-features-description")}</Typography.Text>
          </div>

          <div className="name-change-modal-info-container">
            <Typography.Text className="name-change-modal-info-title">{t("name-change-account-title")}</Typography.Text>
            <Typography.Text className="name-change-modal-info-description">{t("name-change-account-description")}</Typography.Text>
          </div>

          <div className="name-change-modal-info-container">
            <Typography.Text className="name-change-modal-info-title text-center">{t("name-change-contact-title")}</Typography.Text>
            <div className="name-change-modal-info-contact-button" onClick={handleContactButtonClicked}>
              <Typography.Text className="name-change-modal-info-contact-button-text">{t("name-change-contact-button")}</Typography.Text>
            </div>
          </div>
        </div>

        {/* <div className="sticky-button-container">
            <button className="sticky-button" onClick={getIt}>
              {t("i-understand")}
            </button>
          </div> */}
      </div>
    </div>
  );
};

export default ApplicationNameChangeModal;
